export default __webpack_public_path__ + "e33e2cf6e02cac2ccb77689015f11c56.svg";